import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aPVyw"), parcelRequire.load("9f8mp"), parcelRequire.load("dOFdr"), parcelRequire.load("i6te6"), parcelRequire.load("jkk6G"), parcelRequire.load("4UxgA"), parcelRequire.load("dZMz1"), parcelRequire.load("c0VSK"), parcelRequire.load("lfyA4")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aPVyw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("dOFdr")} />
  <link rel="modulepreload" href={parcelRequire.resolve("i6te6")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jkk6G")} />
  <link rel="modulepreload" href={parcelRequire.resolve("4UxgA")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dZMz1")} />
  <link rel="modulepreload" href={parcelRequire.resolve("c0VSK")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lfyA4")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
